import Supplier from "../SupplierList.vue";
import CreateSupplier from "../SupplierCreate.vue";
import SupplierSetup from "../workspace/SupplierWorkspace.vue";
import SupplierConfirm from "../confirm/BookingConfirm.vue";
import SupplierConfirmPayment from "../confirm/PaymentConfirm.vue";

export default [
  {
    path: "/supplier",
    name: "/supplier",
    meta: { layout: 'mystagit' },
    component: Supplier,
  },
  {
    path: "/create-supplier",
    name: "/create-supplier",
    meta: { layout: 'mystagit' },
    component: CreateSupplier,
  },
  {
    path: "/supplier-setup/:supplier_id",
    name: "/supplier-setup",
    meta: { layout: 'mystagit', company_record: { type: 'supplier', param: 'supplier_id' } },
    component: SupplierSetup,
  },
  {
    path: "/supplier-setup/:supplier_id/product/:product_id",
    name: "/supplier-setup/product/setup",
    meta: { layout: 'mystagit', company_record: { type: 'product', param: 'product_id' } },
    component: () =>
      import("../workspace/product/ProductEditPage.vue"),
  },
  {
    path: "/supplier-setup/:supplier_id/create-product",
    name: "/supplier-setup/create-product",
    meta: { layout: 'mystagit', company_record: { type: 'supplier', param: 'supplier_id' } },
    component: () =>
      import("../workspace/product/ProductCreatePage.vue"),
  },
  {
    path: "/supplier_confirm/:event_id/:supplier_id/:build_ids",
    name: "/supplier_confirm/:event_id/:supplier_id/:build_ids",
    meta: { layout: 'blank' },
    component: SupplierConfirm,
  },
  {
    path: "/supplier_confirm_cancellation/:event_id/:supplier_id/:build_ids",
    name: "/supplier_confirm_cancellation/:event_id/:supplier_id/:build_ids",
    meta: { layout: 'blank' },
    component: () => import("../confirm/CancellationConfirm.vue"),
  },
  {
    path: "/supplier_availability/:token",
    name: "/supplier_availability/:token",
    meta: { layout: 'blank' },
    component: () => import("../confirm/AvailabilityConfirm.vue"),
  },
  {
    path: "/supplier_confirm_payment/:event_id/:supplier_id/:build_ids",
    name: "/supplier_confirm_payment/:event_id/:supplier_id/:build_ids",
    meta: { layout: 'blank' },
    component: SupplierConfirmPayment,
  },
];
